import { Link } from 'react-router-dom';
import type { ContentItem } from '@/lib/content';
import SectionHeading from '@/components/feature/SectionHeading';

export default function NewsHighlights({ items }: { items: ContentItem[] }) {
  if (!items.length) return null;
  const [feature, ...rest] = items;

  return (
    <section className="w-full border-y border-background-200/60 bg-background-100/30 px-4 md:px-8 lg:px-12 py-14 md:py-20">
      <SectionHeading
        eyebrow="NEWS"
        title="影视资讯：幕后与讨论"
        description="收官剧评、拍摄手记、主创专访与观众讨论。按发布时间倒序更新，记录这部剧从播出到收尾的每一个话题。"
        moreTo="/news"
        moreLabel="全部资讯"
      />

      <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-[1.15fr_1fr]">
        <Link
          to={`/detail/${feature.id}`}
          className="group relative flex min-h-[320px] flex-col justify-end overflow-hidden rounded-lg border border-background-200/80 bg-background-100 md:min-h-[420px]"
        >
          <img
            src={feature.image}
            alt={`${feature.title} 配图`}
            title={`${feature.title} - 影视资讯`}
            className="absolute inset-0 h-full w-full object-cover object-top opacity-80 transition-transform duration-700 ease-smooth group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/70 to-transparent"></div>
          <div className="relative p-5 md:p-7">
            <div className="flex flex-wrap items-center gap-2 text-[11px]">
              <span className="rounded-full bg-primary-500 px-2.5 py-0.5 text-background-50">头条</span>
              <span className="text-foreground-400">{feature.dateLabel}</span>
              <span className="text-foreground-600">·</span>
              <span className="text-foreground-400">{feature.tags[0]}</span>
            </div>
            <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-300 md:text-2xl">
              {feature.title}
            </h3>
            <p className="mt-2 line-clamp-2 max-w-xl text-sm leading-relaxed text-foreground-400">
              {feature.excerpt}
            </p>
          </div>
        </Link>

        <div className="flex flex-col divide-y divide-background-200/70 rounded-lg border border-background-200/80 bg-background-100">
          {rest.map((item) => (
            <Link key={item.id} to={`/detail/${item.id}`} className="group flex gap-4 p-4 md:p-5">
              <div className="h-20 w-24 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-32">
                <img
                  src={item.image}
                  alt={`${item.title} 配图`}
                  title={`${item.title} - 影视资讯`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 ease-smooth group-hover:scale-105"
                />
              </div>
              <div className="min-w-0">
                <span className="text-[11px] text-foreground-500">{item.dateLabel} · {item.tags[0]}</span>
                <h3 className="mt-1 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-400 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{item.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}